import { Component, OnInit, inject, signal, computed } from '@angular/core';
import {GameService} from "../../services/game.service";
import {GameListService} from '../../services/game-list.service';
import {gameDemo, GameInfo} from '../../model/game';
import {LoadingService} from "../../services/loading.service";
import {GameStatus} from "../../model/gameStatus";
import {GameType} from "../../model/gameType";
import {Sentry} from "../../../sentry/sentry";
import {MessageDialogService} from "../../services/message-dialog.service";
import { MatCard } from '@angular/material/card';
import { DatePipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonToggleGroupComponent } from '../button-toggle-group/button-toggle-group.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';

export enum GameStatusFilter {
  All = 'all',
  Scheduled = 'scheduled',
  InProgress = 'inProgress',
  Completed = 'completed',
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [MatCard, DatePipe, TranslocoModule, ButtonToggleGroupComponent, MatButtonToggleGroup, MatButtonToggle]
})
export class HomeComponent implements OnInit{
  game = inject(GameService);
  private gameList = inject(GameListService);
  private loadingService = inject(LoadingService);
  private messageDialog = inject(MessageDialogService);

  private allGames = signal<GameInfo[]>([]);
  statusFilter = signal<GameStatusFilter>(GameStatusFilter.All);

  gamesInfo = computed<GameInfo[]>(() => {
    const games = this.allGames();
    switch (this.statusFilter()) {
      case GameStatusFilter.Scheduled:
        return games.filter(g => g.gameStatus === GameStatus.scheduled);
      case GameStatusFilter.InProgress:
        return games.filter(g => g.gameStatus === GameStatus.InProgress || g.gameStatus === GameStatus.InReview || g.gameStatus === GameStatus.Pending);
      case GameStatusFilter.Completed:
        return games.filter(g => g.gameStatus === GameStatus.Completed);
      default:
        return games;
    }
  });

  ngOnInit(): void {
    if (!this.isGameSelected()) {
      this.initGameList()
    } else {
      this.game.reloadGame()
    }
  }

  isGameSelected(): boolean {
    return !!window.localStorage.getItem('gameInfo')
  }

  selectStatusFilter(filter: GameStatusFilter) {
    this.statusFilter.set(filter);
  }

  showScore(gameInfo: GameInfo): boolean {
    return gameInfo.gameStatus !== GameStatus.scheduled;
  }

  initGameList() {
    this.loadingService.setLoading(true);
    this.gameList.getGames().subscribe({
      next: data => {
        this.allGames.set(data);
      },
      error: error => {
        console.error('Error: ' + error);
        this.allGames.update(games => [...games, gameDemo]);
        Sentry.captureMessage(`Impossible de charger les games.`);
        this.messageDialog.openMessage(
          'validation.errorTitle',
          'validation.unableToLoadGames',
          'app.ok',
          'error',
        )
        this.loadingService.setLoading(false);
      },
      complete: () => {
        console.log('Games Loaded!');
        this.allGames.update(games => [...games, gameDemo]);
        this.loadingService.setLoading(false);
      }
    });
  }

  protected readonly GameStatusFilter = GameStatusFilter;
  protected readonly GameType = GameType;
}

